module.exports = __webpack_public_path__ + "static/media/3.6f8a027f.svg";